
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as entity from '../entity'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Request} from '../core/Request';
import {FieldModelRequest} from '../core/Request';
import {ChartBarHistoryLastModifiedRangeResponse} from './ChartBarHistoryLastModifiedRangeResponse';

/**
 * ChartBarHistoryLastModifiedRangeRequest struct
 */
class ChartBarHistoryLastModifiedRangeRequest extends Request {
  /**
   * Initialize struct
   * @param {!Request=} parent
   * @param {!number=} fromVersionGreater
   * @param {!number=} limit
   * @param {!boolean=} includeSymbols
   * @constructor
   */
  constructor (parent = new Request(), fromVersionGreater = new UInt64(0, 0), limit = 0, includeSymbols = false) {
    super()
    super.copy(parent)
    this.FromVersionGreater = fromVersionGreater
    this.Limit = limit
    this.IncludeSymbols = includeSymbols
  }

  /**
   * Copy struct (shallow copy)
   * @this {!ChartBarHistoryLastModifiedRangeRequest}
   * @param {!ChartBarHistoryLastModifiedRangeRequest} other Other struct
   * @returns {!ChartBarHistoryLastModifiedRangeRequest} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.FromVersionGreater != null) {
      this.FromVersionGreater = UInt64.fromNumber(other.FromVersionGreater)
    } else {
      this.FromVersionGreater = null
    }
    if (other.Limit != null) {
      this.Limit = other.Limit
    } else {
      this.Limit = null
    }
    if (other.IncludeSymbols != null) {
      this.IncludeSymbols = other.IncludeSymbols
    } else {
      this.IncludeSymbols = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!ChartBarHistoryLastModifiedRangeRequest}
   * @returns {!ChartBarHistoryLastModifiedRangeRequest} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new ChartBarHistoryLastModifiedRangeRequestModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new ChartBarHistoryLastModifiedRangeRequestModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!ChartBarHistoryLastModifiedRangeRequest}
   * @param {!ChartBarHistoryLastModifiedRangeRequest} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof ChartBarHistoryLastModifiedRangeRequest)) {
      throw new TypeError('Instance of ChartBarHistoryLastModifiedRangeRequest is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!ChartBarHistoryLastModifiedRangeRequest}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      FromVersionGreater: ((this.FromVersionGreater != null) ? this.FromVersionGreater.toNumber() : null),
      Limit: ((this.Limit != null) ? this.Limit : null),
      IncludeSymbols: ((this.IncludeSymbols != null) ? this.IncludeSymbols : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return ChartBarHistoryLastModifiedRangeRequest.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!ChartBarHistoryLastModifiedRangeRequest} other Object value
   * @returns {!ChartBarHistoryLastModifiedRangeRequest} Created struct
   */
  static fromObject (other) {
    return new ChartBarHistoryLastModifiedRangeRequest().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!ChartBarHistoryLastModifiedRangeRequest}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return ChartBarHistoryLastModifiedRangeRequest.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!ChartBarHistoryLastModifiedRangeRequest}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 3025
  }
}

export { ChartBarHistoryLastModifiedRangeRequest };

/**
 * Fast Binary Encoding ChartBarHistoryLastModifiedRangeRequest field model
 */
class FieldModelChartBarHistoryLastModifiedRangeRequest extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelRequest(buffer, 4 + 4)
    this.FromVersionGreater = new fbe.FieldModelUInt64(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
    this.Limit = new fbe.FieldModelUInt32(buffer, this.FromVersionGreater.fbeOffset + this.FromVersionGreater.fbeSize)
    this.IncludeSymbols = new fbe.FieldModelBool(buffer, this.Limit.fbeOffset + this.Limit.fbeSize)
  }

  /**
   * Get the core.Request field model
   * @this {!FieldModelChartBarHistoryLastModifiedRangeRequest}
   * @returns {!FieldModelRequest} core.Request field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelChartBarHistoryLastModifiedRangeRequest}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelChartBarHistoryLastModifiedRangeRequest}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.FromVersionGreater.fbeSize + this.Limit.fbeSize + this.IncludeSymbols.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelChartBarHistoryLastModifiedRangeRequest}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.FromVersionGreater.fbeExtra + this.Limit.fbeExtra + this.IncludeSymbols.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelChartBarHistoryLastModifiedRangeRequest}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelChartBarHistoryLastModifiedRangeRequest.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelChartBarHistoryLastModifiedRangeRequest}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 3025
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelChartBarHistoryLastModifiedRangeRequest}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelChartBarHistoryLastModifiedRangeRequest}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.FromVersionGreater.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.FromVersionGreater.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.FromVersionGreater.fbeSize

    if ((fbeCurrentSize + this.Limit.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Limit.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Limit.fbeSize

    if ((fbeCurrentSize + this.IncludeSymbols.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.IncludeSymbols.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IncludeSymbols.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelChartBarHistoryLastModifiedRangeRequest}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelChartBarHistoryLastModifiedRangeRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelChartBarHistoryLastModifiedRangeRequest}
   * @param {!ChartBarHistoryLastModifiedRangeRequest} fbeValue Default value, defaults is new ChartBarHistoryLastModifiedRangeRequest()
   * @returns {!ChartBarHistoryLastModifiedRangeRequest} ChartBarHistoryLastModifiedRangeRequest value
   */
  get (fbeValue = new ChartBarHistoryLastModifiedRangeRequest()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelChartBarHistoryLastModifiedRangeRequest}
   * @param {!ChartBarHistoryLastModifiedRangeRequest} fbeValue ChartBarHistoryLastModifiedRangeRequest value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.FromVersionGreater.fbeSize) <= fbeStructSize) {
      fbeValue.FromVersionGreater = this.FromVersionGreater.get()
    } else {
      fbeValue.FromVersionGreater = new UInt64(0, 0)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.FromVersionGreater.fbeSize

    if ((fbeCurrentSize + this.Limit.fbeSize) <= fbeStructSize) {
      fbeValue.Limit = this.Limit.get()
    } else {
      fbeValue.Limit = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Limit.fbeSize

    if ((fbeCurrentSize + this.IncludeSymbols.fbeSize) <= fbeStructSize) {
      fbeValue.IncludeSymbols = this.IncludeSymbols.get()
    } else {
      fbeValue.IncludeSymbols = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IncludeSymbols.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelChartBarHistoryLastModifiedRangeRequest}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelChartBarHistoryLastModifiedRangeRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelChartBarHistoryLastModifiedRangeRequest}
   * @param {!ChartBarHistoryLastModifiedRangeRequest} fbeValue ChartBarHistoryLastModifiedRangeRequest value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelChartBarHistoryLastModifiedRangeRequest}
   * @param {ChartBarHistoryLastModifiedRangeRequest} fbeValue ChartBarHistoryLastModifiedRangeRequest value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.FromVersionGreater.set(fbeValue.FromVersionGreater)
    this.Limit.set(fbeValue.Limit)
    this.IncludeSymbols.set(fbeValue.IncludeSymbols)
  }
}

export { FieldModelChartBarHistoryLastModifiedRangeRequest };

/**
 * Fast Binary Encoding ChartBarHistoryLastModifiedRangeRequest model
 */
class ChartBarHistoryLastModifiedRangeRequestModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelChartBarHistoryLastModifiedRangeRequest(this.buffer, 4)
  }

  /**
   * Get the ChartBarHistoryLastModifiedRangeRequest model
   * @this {!ChartBarHistoryLastModifiedRangeRequestModel}
   * @returns {!FieldModelChartBarHistoryLastModifiedRangeRequest} model ChartBarHistoryLastModifiedRangeRequest model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!ChartBarHistoryLastModifiedRangeRequestModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!ChartBarHistoryLastModifiedRangeRequestModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return ChartBarHistoryLastModifiedRangeRequestModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!ChartBarHistoryLastModifiedRangeRequestModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelChartBarHistoryLastModifiedRangeRequest.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!ChartBarHistoryLastModifiedRangeRequestModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!ChartBarHistoryLastModifiedRangeRequestModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!ChartBarHistoryLastModifiedRangeRequestModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!ChartBarHistoryLastModifiedRangeRequestModel}
   * @param {!ChartBarHistoryLastModifiedRangeRequest} value ChartBarHistoryLastModifiedRangeRequest value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!ChartBarHistoryLastModifiedRangeRequestModel}
   * @param {!ChartBarHistoryLastModifiedRangeRequest} value ChartBarHistoryLastModifiedRangeRequest value, defaults is new ChartBarHistoryLastModifiedRangeRequest()
   * @return {!object} Deserialized ChartBarHistoryLastModifiedRangeRequest value and its size
   */
  deserialize (value = new ChartBarHistoryLastModifiedRangeRequest()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new ChartBarHistoryLastModifiedRangeRequest(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new ChartBarHistoryLastModifiedRangeRequest(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!ChartBarHistoryLastModifiedRangeRequestModel}
   * @param {!number} prev Previous ChartBarHistoryLastModifiedRangeRequest model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { ChartBarHistoryLastModifiedRangeRequestModel };
ChartBarHistoryLastModifiedRangeRequest.__has_response = true;
ChartBarHistoryLastModifiedRangeRequest.__response_class = ChartBarHistoryLastModifiedRangeResponse;
